
<template>
        <div class="stepperButtonWrapper"><div class="stepperButton" @click="decreaseRatings()">-</div> <span class="icon" :class="ratingOrIconClass">{{(rating > 0 ? '+' : '')}}{{ratingOrIcon}}</span> <div class="stepperButton" @click="increaseRatings()" style="margin-left:34px">+</div>
        <div class="confirmRatings" :class="ratingsUpdated" v-if="rating !== 0" @click="confirmRatings()"><span class="icon" :class="checkOrThumbs"></span></div>
        </div>
</template>

<script>
export default {
    name: 'ratingsStepper',
    data () {
        return {
            rating: 0,
            updated: false,
        };
    },
    computed: {
        ratingOrIconClass () {
            return (this.rating === 0 ? 'icon icon-award' : '');
        },
        ratingOrIcon () {
            return (this.rating !== 0 ? this.rating : '');
        },
        ratingsUpdated () {
            return (this.updated ? 'updated' : '');
        },
        checkOrThumbs () {
            return (this.updated ? 'icon-thumbs-up' : 'icon-check');
        },
    },
    methods: {
        increaseRatings () {
            if (this.rating < 9) {
                ++this.rating;
            }
        },
        decreaseRatings () {
            if (this.rating > -9) {
                --this.rating;
            }
        },
        confirmRatings () {
            this.updated = !this.updated;
            const obj = this;
            setTimeout(() => {
                obj.updated = false;
                obj.rating = 0;
            }, 2000);
            this.$store.commit('updateBulkRatings', this.rating);
        },
    },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import 'src/assets/scss/all.scss';
.stepperButtonWrapper{
    display: inline-block;
    .icon{
        position: absolute;
        font-size: 22px;
        color: $midGrey;
        width: 20px;
        text-align: center;
        line-height: 30px;
    }
}
.stepperButton{
    background:$darkBlue;
    padding: 6px 12px;
    text-align: center;
    border-radius: 6px;
    color: white;
    cursor: pointer;
    position: relative;
    display: inline-block;
    margin: 0 10px;
    vertical-align: middle;
    user-select: none;
}
.confirmRatings{
    background:$LCPBlue;
    padding: 6px 12px;
    text-align: center;
    border-radius: 6px;
    color: white;
    cursor: pointer;
    position: relative;
    display: inline-block;
    margin: 0 10px;
    vertical-align: middle;
    user-select: none;
    .icon{
        position: unset;
        font-size: 16px;
        color: #FFF;
        width: 26px;
        text-align: unset;
        line-height: unset;
        vertical-align: middle;
    }
    &.updated{
        background-color: $LCPAquamarine;
    }
}
</style>
